export const socialConnectionsData = [
    {
        imgSrc: '/images/brand/facebook.png',
        title: 'Facebook: The World Most Popular Social Network',
        description: 'Create an account or log into Facebook. Connect with friends, family and other people you know. Share photos and videos, send messages and get updates.',
        switchId: 'formSwitchFacebook',
        isChecked: true,
    },
    {
        imgSrc: '/images/brand/instagram.png',
        title: 'Instagram: Edit & Share photos, Videos & Dessages',
        description: 'Create an account or log in to Instagram - A simple, fun & creative way to capture, edit & share photos, videos & messages with friends & family.',
        switchId: 'formSwitchInstagram',
        isChecked: false,
    },
    {
        imgSrc: '/images/brand/twitter.png',
        title: "Twitter: It's what's happening / Twitter",
        description: 'From breaking news and entertainment to sports and politics, get the full story with all the live commentary.',
        switchId: 'formSwitchTwitter',
        isChecked: true,
    },
    {
        imgSrc: '/images/brand/spotify.png',
        title: 'Spotify: Web Player: Music for everyone',
        description: 'Spotify is a digital music service that gives you access to millions of songs.',
        switchId: 'formSwitchSpotify',
        isChecked: true,
    },
    {
        imgSrc: '/images/brand/youtube.png',
        title: 'YouTube: The World Largest Video Sharing Platform',
        description: 'Enjoy the videos and music you love, upload original content, and share it all with friends, family, and the world on YouTube.',
        switchId: 'formSwitchYouTube',
        isChecked: false,
    },
    {
        imgSrc: '/images/brand/pinterest.png',
        title: 'Pinterest: Discover recipes, home ideas, style inspiration and other ideas to try',
        description: 'Pinterest is an image sharing and social media service designed to enable saving and discovery of information on the internet using images.',
        switchId: 'formSwitchPinterest',
        isChecked: true,
    },
]